// Auth endpoints + token storage helpers.
// After login, tokens are persisted via setAuth() so subsequent api() calls
// automatically include the Authorization header.

import { api, setAuth } from "./clientService";
import type { LoginEmailRequest } from "../interface/requests/authRequest";
import type { LoginEmailResponse } from "../interface/responses/authResponse";

/** POST /api/v1/auth/operator/login */
export async function loginWithEmail(payload: LoginEmailRequest) {
  const data = await api<LoginEmailResponse>("/api/v1/auth/operator/login", {
    method: "POST",
    body: JSON.stringify(payload),
  });

  setAuth({
    accessToken: data.accessToken,
    refreshToken: data.refreshToken,
    tokenExpires: data.tokenExpires,
    userId: data.userId,
    email: payload.email, // <--- add this
  } as any); // you can extend StoredAuth type to include email
  return data;
}

/** Local logout: clear tokens (call server logout if available) */
export async function logoutLocal() {
  setAuth(null);
}

/** Example (optional): if you add a /auth/me later */
// export async function fetchMe() {
//   return api<MeResponse>("/api/v1/auth/me", { method: "GET" });
// }
